// word to html
export default {
	policy: `<p style="margin-top:0pt; margin-bottom:0pt; text-align:center; widows:2; orphans:2; font-size:16pt">
		<strong><span style="font-family:'Baskerville Old Face'; ">Website Privacy Policy</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">This privacy policy</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">version</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">shall come into force on August 1, 2021. Continued use
			of</span><span style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">AirClass</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">after that date constitutes acceptance of our updated terms of
			use.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<strong><span style="font-family:'Baskerville Old Face'; ">1. Who is responsible for data
				processing?</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">The person responsible for data processing is</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">AirClass (Singapore) PTE. LTD.</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">incorporated,
			in Singapore with registration number</span><span
			style="font-family:'Times New Roman'; color:#6f777b; background-color:#ffffff">&#xa0;</span><span
			style="font-family:'Times New Roman'; color:#6f777b; background-color:#ffffff">202129373C.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<strong><span style="font-family:'Baskerville Old Face'; ">2. What data is processed and where does this data
				originate?</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">We process the personal data that we receive from you within
			the bounds of the business relationship. When we do so we are subject to the </span><strong><span
				style="font-family:'Baskerville Old Face'; ">The Personal Data Protection Act 2012 </span></strong><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">(Singapore PDPA). </span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">We collect personal data from you:</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Directly, when you enter or send us information, such as when
			you register with us, contact us (including via email), send us feedback, purchase services via our website,
			post material to our website and complete customer surveys, and</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Indirectly, such as your browsing activity while on our
			website; we will collect information indirectly using “cookies”, which is detailed below</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">The personal data collected includes:</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Type of school</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Year group</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Telephone number</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Email address, if provided</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Questions that are put to the community</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Responses returned to the community</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Payment information, if provided</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Profile picture, if uploaded</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Identification data of the device on which the</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">AirClass</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">app
			has been installed.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Your answers to the particular</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">subjects</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">about</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">your</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">school, if</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">disclosed</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Profile description, if provided</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Information relevant to teaching (such as dates of
			examinations, grades, learning disabilities etc.), if provided</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<strong><span style="font-family:'Baskerville Old Face'; ">3. Cookies</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Cookies are used on this website to simplify the use of this
			website and communication, and to better adapt our web presence to your needs. A cookie is a small text file
			that is stored on your hard drive by a website. Cookies do not damage your computer and do not contain
			viruses. You can deactivate the use of cookies at any time in your browser settings.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<strong><span style="font-family:'Baskerville Old Face'; ">4. Google Analytics</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">We also use Google Analytics on this website. This is a service
			provided by Google Inc, 1600 Amphitheatre Parkway, Mountain View, CA 94043, United States (“Google”). Google
			uses “cookies”, i.e. text files which are stored on your computer and which enable analysis of your use of
			our online offers. The information generated by cookies about your use of this website (including your IP
			address) is transferred to a Google server in the USA and stored there. Google is registered with
			the</span><span style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">“EU-US Privacy Shield” program of the US Department of Commerce.
			Google will use this information for the purpose of evaluating your use of the website, compiling reports on
			website activity for us and providing other services relating to website activity and internet usage. Third
			parties, including Google, use stored cookies to place ads based on a user’s previous visits to our website.
			Google may also transfer this information to third parties where required to do so by law, or where such
			third parties process the information on Google’s behalf. Google will not associate your IP address with any
			other data held by Google. You may refuse the use of cookies by selecting the appropriate settings on your
			browser. However, please note that if you do this you may not be able to use the full functionality of this
			website. By using this website, you agree to the processing of the data collected about you by Google in the
			manner and for the purpose described above. The collection and storage of data can be refused at any time,
			with the change coming into effect after the refusal. You can deactivate the use of cookies by Google by
			accessing the page for deactivating Google advertising (http://www.google.com/privacy_ads.html).
			Alternatively, users can deactivate the use of cookies by third-party providers by accessing the
			deactivation page of the network advertising initiative
			(http://www.networkadvertising.org/managing/opt_out.asp).</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<strong><span style="font-family:'Baskerville Old Face'; ">5.</span></strong><strong><span
				style="font-family:'Baskerville Old Face'; ">&#xa0;</span></strong><strong><span
				style="font-family:'Baskerville Old Face'; ">How does</span></strong><strong><span
				style="font-family:'Baskerville Old Face'; ">&#xa0;</span></strong><strong><span
				style="font-family:'Baskerville Old Face'; ">AirClass</span></strong><strong><span
				style="font-family:'Baskerville Old Face'; ">&#xa0;</span></strong><strong><span
				style="font-family:'Baskerville Old Face'; ">use the collected information?</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<strong><span style="font-family:'Baskerville Old Face'; ">&#xa0;</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">We may use the information we collected, including your and
			your children’s personal</span><span style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">information - based on diverse purposes as well as the legal
			basis of the processing – as</span><span style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">follows:</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">5.1</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">We
			process the following personal data for the purpose and on the legal basis of the</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">performance of the contract, product and service
			fulfillment:</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Full</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">name,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Children</span><span style="font-family:宋体">’</span><span
			style="font-family:'Baskerville Old Face'">s name,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Children’s age,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Children’s gender,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">E-mail address,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Phone number.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">The above obligatory or optional personal data you provide is
			used for purposes such as</span><span style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">fulfilling the obligations defined in the</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">Online Terms and Conditions</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">And</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">Registration Agreement, responding to</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">your questions, requests relating to the service, customizing the
			visualized content,</span><span style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">communicating with you about sales offers relating to special
			services and new features,</span><span style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">and responding to problems relating to our services.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">5.2</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">We
			process the following personal information based on</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">the
			legitimate interest of the</span><span style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">AirClass</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">(as
			the legal basis of this processing) for marketing purposes and to deliver</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">e-mails:</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Full</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">name,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Phone number,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Any other personal data provided to the data processors
			of</span><span style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">AirClass.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Whenever</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">AirClass</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">processes data for its legitimate interest,</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">AirClass</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">always keeps your</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">personal data rights in high regard and will take them
			in</span><span style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">account. The users always have</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">the
			right to object to this processing. However, objecting against such data processing might</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">affect</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">AirClass’s</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">ability to carry out tasks above for the benefit of the
			user.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">5.3</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">We
			process personal data for the purpose and on the</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">legal basis of</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><strong><span
				style="font-family:'Baskerville Old Face'; ">compliance with legal obligations</span></strong><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">to
			prevent fraudulent transactions, monitor against theft and otherwise</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">protect our customers and our business. We also process personal
			data for the purpose</span><span style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">and on the legal basis of</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><strong><span
				style="font-family:'Baskerville Old Face'; ">legal compliance</span></strong><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">and
			to assist</span><span style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">law enforcement and respond to</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">subpoenas.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">5.4</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">We
			process the following personal data for the purpose and on the legal basis of the</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">legitimate interests of</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">us</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">to
			improve the effectiveness of the Website, our</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">services, and marketing efforts, to conduct research and
			analysis, including focus groups</span><span style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">and surveys and to perform other business</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">activities as needed, or as described elsewhere</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">in
			this Policy:</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">IP address,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Browser information,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Contact information,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Content consumed on the Website,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Unique device identifier,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Browser characteristics,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Domain and other system settings,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Search queries,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Device characteristics,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Operating system type,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Language preferences,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Referring URLs,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Actions taken on our Website,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Page requested,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Content consumed (e.g., viewed, uploaded, and shared),</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Dates and times of Website visits,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">The link that you have been redirected to our Website
			from,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Gender,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Age range,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">The type of web browser used,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Actions taken in the Application,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Dates and times of using the Application,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Time spent in the Application and the regularity of your
			visits,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Other software and hardware information,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Other information associated with other files stored on your
			device.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Picture,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Video,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Audio,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Crash log,</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Installed application. Airclass collects installed application
			to enable users share information to third-party apps and login with a third-party account.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<strong><span style="font-family:'Baskerville Old Face'; ">&#xa0;</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Device information: The platform will receive and record
			information about the device you are using (IMEI number, device model, OS version, device settings, unique
			device identifier hardware and software characteristics, device information (IMEI/MAC/Android
			ID/IDFA/OpenUDID/GUID/SIM card IMSI information, etc.)) and information about the location of the device (IP
			address, GPS and other sensor information) according to the specific permissions you have granted during the
			software installation and use.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<strong><span style="font-family:'Baskerville Old Face'; ">&#xa0;</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Where it is feasible, we anonymize personal data or use
			non-identifiable statistical data. We do not collect personal data in advance and store it for potential
			future purposes unless required or permitted by the applicable laws.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">For collecting anonymously, the above-mentioned data and making
			statistics and analysis we may use the following software and programs:</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<table cellspacing="0" cellpadding="0" style="width:534pt; border:1.5pt solid #000000; border-collapse:collapse">
		<tr style="height:21.45pt">
			<td
				style="width:152.3pt; border-right-style:solid; border-right-width:1.5pt; border-bottom-style:solid; border-bottom-width:1.5pt; vertical-align:middle">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<strong><span style="font-family:'Baskerville Old Face'; ">Name</span></strong>
				</p>
			</td>
			<td
				style="width:203.1pt; border-right-style:solid; border-right-width:1.5pt; border-left-style:solid; border-left-width:1.5pt; border-bottom-style:solid; border-bottom-width:1.5pt; vertical-align:middle">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<strong><span style="font-family:'Baskerville Old Face'; ">Registered seat</span></strong>
				</p>
			</td>
			<td
				style="width:171.25pt; border-left-style:solid; border-left-width:1.5pt; border-bottom-style:solid; border-bottom-width:1.5pt; vertical-align:middle">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<strong><span style="font-family:'Baskerville Old Face'; ">Country</span></strong>
				</p>
			</td>
		</tr>
		<tr style="height:41.7pt">
			<td
				style="width:152.3pt; border-top-style:solid; border-top-width:1.5pt; border-right-style:solid; border-right-width:1.5pt; border-bottom-style:solid; border-bottom-width:1.5pt; vertical-align:top">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<span style="font-family:'Baskerville Old Face'">Firebase</span>
				</p>
			</td>
			<td style="width:203.1pt; border-style:solid; border-width:1.5pt; vertical-align:top">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<span style="font-family:'Baskerville Old Face'">1600 Amphitheatre Parkway Mountain View, CA
						94043</span>
				</p>
			</td>
			<td
				style="width:171.25pt; border-top-style:solid; border-top-width:1.5pt; border-left-style:solid; border-left-width:1.5pt; border-bottom-style:solid; border-bottom-width:1.5pt; vertical-align:top">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<span style="font-family:'Baskerville Old Face'">United States of America</span>
				</p>
			</td>
		</tr>
		<tr style="height:28.45pt">
			<td
				style="width:152.3pt; border-top-style:solid; border-top-width:1.5pt; border-right-style:solid; border-right-width:1.5pt; border-bottom-style:solid; border-bottom-width:1.5pt; vertical-align:top">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<span style="font-family:'Baskerville Old Face'">Jiyan</span>
				</p>
			</td>
			<td style="width:203.1pt; border-style:solid; border-width:1.5pt; vertical-align:top">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<span style="font-family:'Baskerville Old Face'">8F, Building B3, Phase II,</span><span
						style="font-family:'Baskerville Old Face'">&#xa0;</span><span
						style="font-family:'Baskerville Old Face'">Wuda</span><span
						style="font-family:'Baskerville Old Face'">&#xa0;</span><span
						style="font-family:'Baskerville Old Face'">Airfield, East Lake New Technology Development Zone,
						Wuhan, China</span>
				</p>
			</td>
			<td
				style="width:171.25pt; border-top-style:solid; border-top-width:1.5pt; border-left-style:solid; border-left-width:1.5pt; border-bottom-style:solid; border-bottom-width:1.5pt; vertical-align:top">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<span style="font-family:'Baskerville Old Face'">China</span>
				</p>
			</td>
		</tr>
		<tr style="height:40.45pt">
			<td
				style="width:152.3pt; border-top-style:solid; border-top-width:1.5pt; border-right-style:solid; border-right-width:1.5pt; border-bottom-style:solid; border-bottom-width:1.5pt; vertical-align:top">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<span style="font-family:'Baskerville Old Face'">TalkingData</span>
				</p>
			</td>
			<td style="width:203.1pt; border-style:solid; border-width:1.5pt; vertical-align:top">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<span style="font-family:'Baskerville Old Face'">Building 2,</span><span
						style="font-family:'Baskerville Old Face'">&#xa0;</span><span
						style="font-family:'Baskerville Old Face'">No.39</span><span
						style="font-family:'Baskerville Old Face'">&#xa0;</span><span
						style="font-family:'Baskerville Old Face'">Dongzhimenwai</span><span
						style="font-family:'Baskerville Old Face'">&#xa0;</span><span
						style="font-family:'Baskerville Old Face'">Street,</span><span
						style="font-family:'Baskerville Old Face'">&#xa0;</span><span
						style="font-family:'Baskerville Old Face'">Dongcheng</span><span
						style="font-family:'Baskerville Old Face'">&#xa0;</span><span
						style="font-family:'Baskerville Old Face'">District, Beijing,</span><span
						style="font-family:'Baskerville Old Face'">&#xa0;</span><span
						style="font-family:'Baskerville Old Face'">China</span>
				</p>
			</td>
			<td
				style="width:171.25pt; border-top-style:solid; border-top-width:1.5pt; border-left-style:solid; border-left-width:1.5pt; border-bottom-style:solid; border-bottom-width:1.5pt; vertical-align:top">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<span style="font-family:'Baskerville Old Face'">China</span>
				</p>
			</td>
		</tr>
		<tr style="height:41.7pt">
			<td
				style="width:152.3pt; border-top-style:solid; border-top-width:1.5pt; border-right-style:solid; border-right-width:1.5pt; vertical-align:top">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<span style="font-family:'Baskerville Old Face'">Youmeng</span>
				</p>
			</td>
			<td
				style="width:203.1pt; border-top-style:solid; border-top-width:1.5pt; border-right-style:solid; border-right-width:1.5pt; border-left-style:solid; border-left-width:1.5pt; vertical-align:top">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<span style="font-family:'Baskerville Old Face'">Room902, Building 9, Wangjing East Garden 4,
						Chaoyang District, Beijing, China</span>
				</p>
			</td>
			<td
				style="width:171.25pt; border-top-style:solid; border-top-width:1.5pt; border-left-style:solid; border-left-width:1.5pt; vertical-align:top">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<span style="font-family:'Baskerville Old Face'">China</span>
				</p>
			</td>
		</tr>
	</table>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">5.5</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">Data integrity and purpose limitation:</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">AirClass</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">will only collect and retain personal data which is relevant to
			the purposes for which the data is collected, and we will not use it in a way that is incompatible with such
			purposes unless such use has been subsequently authorized by you. We will take reasonable steps to ensure
			that personal data is reliable for its intended use, accurate, complete and current. We may occasionally
			contact you to determine that your data is still accurate and current.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<strong><span style="font-family:'Baskerville Old Face'; ">&#xa0;</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<strong><span style="font-family:'Baskerville Old Face'; ">6.</span></strong><strong><span
				style="font-family:'Baskerville Old Face'; ">&#xa0;</span></strong><strong><span
				style="font-family:'Baskerville Old Face'; ">Factoring</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">The provider/contractual partner is free to make unrestricted
			use of the services of factor bank(s) with a branch in the European Union (data recipient).</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<strong><span style="font-family:'Baskerville Old Face'; ">7. On what legal basis and for what purposes does the
				data processing take place?</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">We process your personal data to fulfil our contractual
			obligations:</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">1) Optimal matching between the questioner and answerer, so
			that the process can be better tailored for the customer</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">2) Informing users about updates to the</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">AirClass</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">app</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">3) Offering online tutoring 4) Processing customer support
			requests to resolve disputes and service problems. We also process your personal data to fulfil legal
			obligations and for other legitimate interests (especially cookies, web analytics, use for advertising
			purposes such as sending newsletters), provided that your interests in maintaining confidentiality are not
			overridden.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<strong><span style="font-family:'Baskerville Old Face'; ">8. To whom</span></strong><strong><span
				style="font-family:'Baskerville Old Face'; ">&#xa0;</span></strong><strong><span
				style="font-family:'Baskerville Old Face'; ">your data will</span></strong><strong><span
				style="font-family:'Baskerville Old Face'; ">&#xa0;</span></strong><strong><span
				style="font-family:'Baskerville Old Face'; ">be transmitted?</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">We</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">may</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">transmit</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">certain personal information</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">to</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">third party vendors in the</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">Singapore</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">or
			in third countries, who supply software applications, web hosting and other technologies or services for the
			Website and our services (hereinafter: “Data Processor”).</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">We</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">will only provide these third parties with access to information
			that is reasonably necessary to perform their work or comply with the law. Those third parties will never
			use such information for any other purpose except to provide services in connection with the Website and our
			services. During the service of data process, the Data Processor shall abide under the present Policy,
			relevant legislations in force, furthermore the provisions of the existing contracts between him
			and</span><span style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">AirClass.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">We use the data process service of the following Data
			Processors:</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<table cellspacing="0" cellpadding="0" style="width:100%; border:1.5pt solid #000000; border-collapse:collapse">
		<tr style="height:36.45pt">
			<td
				style="width:28.96%; border-right-style:solid; border-right-width:1.5pt; border-bottom-style:solid; border-bottom-width:1.5pt; vertical-align:middle">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<strong><span style="font-family:'Baskerville Old Face'; ">Name</span></strong>
				</p>
			</td>
			<td
				style="width:24%; border-right-style:solid; border-right-width:1.5pt; border-left-style:solid; border-left-width:1.5pt; border-bottom-style:solid; border-bottom-width:1.5pt; vertical-align:middle">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<strong><span style="font-family:'Baskerville Old Face'; ">Registered seat</span></strong>
				</p>
			</td>
			<td
				style="width:17.14%; border-right-style:solid; border-right-width:1.5pt; border-left-style:solid; border-left-width:1.5pt; border-bottom-style:solid; border-bottom-width:1.5pt; vertical-align:middle">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<strong><span style="font-family:'Baskerville Old Face'; ">Country</span></strong>
				</p>
			</td>
			<td
				style="width:29.9%; border-left-style:solid; border-left-width:1.5pt; border-bottom-style:solid; border-bottom-width:1.5pt; vertical-align:middle">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<strong><span style="font-family:'Baskerville Old Face'; ">Activity (data processing
							service)</span></strong>
				</p>
			</td>
		</tr>
		<tr style="height:49.4pt">
			<td
				style="width:28.96%; border-top-style:solid; border-top-width:1.5pt; border-right-style:solid; border-right-width:1.5pt; vertical-align:middle">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<span style="font-family:'Baskerville Old Face'">Alibaba</span><span
						style="font-family:'Baskerville Old Face'">&#xa0;</span><span
						style="font-family:'Baskerville Old Face'">Cloud</span><span
						style="font-family:'Baskerville Old Face'">&#xa0;</span><span
						style="font-family:'Baskerville Old Face'">Computing</span>
				</p>
			</td>
			<td
				style="width:24%; border-top-style:solid; border-top-width:1.5pt; border-right-style:solid; border-right-width:1.5pt; border-left-style:solid; border-left-width:1.5pt; vertical-align:middle">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<span style="font-family:'Baskerville Old Face'">No.12,</span><span
						style="font-family:'Baskerville Old Face'">&#xa0;</span><span
						style="font-family:'Baskerville Old Face'">Turnang</span><span
						style="font-family:'Baskerville Old Face'">&#xa0;</span><span
						style="font-family:'Baskerville Old Face'">Science and Technology Economic Block,</span><span
						style="font-family:'Baskerville Old Face'">&#xa0;</span><span
						style="font-family:'Baskerville Old Face'">Xihu</span><span
						style="font-family:'Baskerville Old Face'">&#xa0;</span><span
						style="font-family:'Baskerville Old Face'">District, Hangzhou, Zhejiang Province</span>
				</p>
			</td>
			<td
				style="width:17.14%; border-top-style:solid; border-top-width:1.5pt; border-right-style:solid; border-right-width:1.5pt; border-left-style:solid; border-left-width:1.5pt; vertical-align:middle">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<span style="font-family:'Baskerville Old Face'">China</span>
				</p>
			</td>
			<td
				style="width:29.9%; border-top-style:solid; border-top-width:1.5pt; border-left-style:solid; border-left-width:1.5pt; vertical-align:middle">
				<p style="margin-top:0pt; margin-bottom:0pt; widows:2; orphans:2; font-size:10.5pt">
					<span style="font-family:'Baskerville Old Face'">Cloud</span><span
						style="font-family:'Baskerville Old Face'">&#xa0;</span><span
						style="font-family:'Baskerville Old Face'">service and</span><span
						style="font-family:'Baskerville Old Face'">&#xa0;</span><span
						style="font-family:'Baskerville Old Face'">Server service</span>
				</p>
			</td>
		</tr>
	</table>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">We only transfer personal data collected from individuals
			located within the </span><strong><span
				style="font-family:'Baskerville Old Face'; ">Singapore</span></strong><span
			style="font-family:'Baskerville Old Face'"> only with the consent of the individuals to a third-party having
			a registered seat outside the </span><strong><span
				style="font-family:'Baskerville Old Face'; ">Singapore</span></strong><span
			style="font-family:'Baskerville Old Face'"> acting as a data processor without the appropriate safeguards
			set out in the PDPA, or when it is necessary for the performance of the contract.</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">AirClass</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">will make every effort to ensure that the personal data
			transferred is safe and secure and that the personal data is processed in a manner consistent with the
			PDPA.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">If there is a legal obligation, we transmit personal data to
			public bodies and institutions (e.g.,</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">law
			enforcement agencies, courts).</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<strong><span style="font-family:'Baskerville Old Face'; ">9. How long will your data be processed and
				stored?</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">We process your personal data only</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">if</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">it
			is necessary. As soon as you withdraw consent, it is automatically deleted.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">We store the personal data required for the fulfilment of the
			contract in any case for the duration of the entire business relationship and beyond that in accordance with
			the statutory storage and documentation obligations (e.g.,</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">in
			accordance with the</span><strong><span style="font-family:'Baskerville Old Face'; "> Singapore
				PDPA</span></strong><span style="font-family:'Baskerville Old Face'">). In addition, we</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">take into account</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">the
			statutory limitation periods, which can be up to 30 years in certain cases.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<strong><span style="font-family:'Baskerville Old Face'; ">10. What rights do you have?</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Right of access to information:</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">If we process your personal data, you have the right to be
			informed about the purposes of the processing, the categories of personal data processed, the recipients of
			such personal data, the storage period, the rights you are entitled to, the origin of the personal data and
			the existence of automated decision-making.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'; background-color:#ffffff">You grant to us a royalty-free,
			perpetual</span><span
			style="font-family:'Baskerville Old Face'; background-color:#ffffff">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'; background-color:#ffffff">licence</span><span
			style="font-family:'Baskerville Old Face'; background-color:#ffffff">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'; background-color:#ffffff">throughout</span><span
			style="font-family:'Baskerville Old Face'; background-color:#ffffff">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'; background-color:#ffffff">our apps</span><span
			style="font-family:'Baskerville Old Face'; background-color:#ffffff">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'; background-color:#ffffff">to use,</span><span
			style="font-family:'Baskerville Old Face'; background-color:#ffffff">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'; background-color:#ffffff">copy</span><span
			style="font-family:'Baskerville Old Face'; background-color:#ffffff">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'; background-color:#ffffff">and reproduce</span><span
			style="font-family:'Baskerville Old Face'; background-color:#ffffff">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">the</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">content and materials produced by</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">us</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">as
			a result of</span><span style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">the performance of the</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">activities</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">online tuition. In each case with an appropriate
			credit</span><span style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'; background-color:#ffffff">in connection with the endorsement of
			the tuition, researching or improvement of the quality of</span><span
			style="font-family:'Baskerville Old Face'; background-color:#ffffff">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'; background-color:#ffffff">AirClass</span><span
			style="font-family:'Baskerville Old Face'; background-color:#ffffff">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'; background-color:#ffffff">and/or its products.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Rectification and deletion:</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">You have the right to request the correction of incorrect or
			incomplete personal data concerning you. You are entitled to request the deletion of personal data
			concerning you if there are no legal obligations on our part to oppose</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">deletion unless</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">the
			processing of the data is lawful.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Restriction of processing:</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">In certain cases, you are entitled to demand that the
			processing of your data be restricted.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Data transferability:</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">You are entitled to request the transfer of your data which you
			have provided to us in a structured, common, and machine-readable format. You have the right to request that
			the personal data be transferred directly by us to a person responsible designated by you, insofar as this
			is technically feasible.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Discrepancy:</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">You are entitled at any time to object to the processing of
			personal data concerning you for reasons arising from your</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">situation. If you object, we will not further process personal
			data concerning you, unless we can prove that our reasons for processing outweigh your interests. You may
			object to the use of your personal data for advertising purposes at any time; in this case we will stop
			processing your data for advertising purposes. To exercise your rights in relation to your data processed by
			us, please contact us via:</span><span style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">contact@air-class.com.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<strong><span style="font-family:'Baskerville Old Face'; ">11. Children’s Privacy</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">We do not collect or retain any personal information from
			children except as needed to facilitate tutoring for that student, who may be a minor.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">AirClass</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">is
			committed to safeguarding the information each User entrusts to</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">AirClass</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">and
			believes that every User should know how it utilizes the information collected from each User. Other than
			free information and materials that do not require any registrations or identifying information, the Site is
			not directed at children under 13 years of age, and</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">AirClass</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">does not knowingly collect personally identifiable information
			from children under 13 years of age online. For the purposes of using the Site as a platform to connect with
			tutors, Parents may supply information such as name or age of their children</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">for</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">AirClass</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">to
			assist facilitate the connection between student and tutor.</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">AirClass</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">may
			store this information in a secure digital format. Parents or guardians of children under 13 years of age
			may review or request the deletion of any personal information previously provided by the child, parent, or
			guardian that is ultimately collected by</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">AirClass,</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">if</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">you
			seek to review or delete such information, contact</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">AirClass</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span style="font-family:'Baskerville Old Face'">at
			the phone number or email address given below indicating what you would like to have done.</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">AirClass</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">will contact you</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">to</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">take the requested action, including but not limited to refusing
			to permit further information collection or use.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<strong><span style="font-family:'Baskerville Old Face'; ">12. Complaints</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<strong><span style="font-family:'Baskerville Old Face'; ">&#xa0;</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">You have the right to contact</span>：
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">Email: contact@air-class.com</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">to file a complaint, to withdraw</span><span
			style="font-family:'Baskerville Old Face'">&#xa0;</span><span
			style="font-family:'Baskerville Old Face'">consent, or object to the use of your personal data for
			advertising purposes if you believe that your data protection rights have been violated.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Baskerville Old Face'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left">
		&#xa0;
	</p>`,
	user: `<p style="margin-top:0pt; margin-bottom:0pt; text-align:center; widows:2; orphans:2; font-size:15pt">
		<strong><span style="font-family:'Times New Roman'; ">Online</span></strong><strong><span
				style="font-family:'Times New Roman'; ">&#xa0;</span></strong><strong><span
				style="font-family:'Times New Roman'; ">Terms and Conditions for</span></strong><strong><span
				style="font-family:'Times New Roman'; ">&#xa0;</span></strong><strong><span
				style="font-family:'Times New Roman'; ">Supply of education service</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:center; widows:2; orphans:2; font-size:15pt">
		<strong><span style="font-family:'Times New Roman'; ">and</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:center; widows:2; orphans:2; font-size:15pt">
		<strong><span style="font-family:'Times New Roman'; ">Registration</span></strong><strong><span
				style="font-family:'Times New Roman'; ">&#xa0;</span></strong><strong><span
				style="font-family:'Times New Roman'; ">Agreement</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">This</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">Online</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">Registration</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">Agreement
			shall commence</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">on</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">August 1,
			2021.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">Welcome to use</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">AirClass</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">online</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">education service, please</span><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">&#xa0;</span></strong><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">read the following important terms and
				conditions before you buy any digital content from us and check that they contain everything you want
				and nothing that you are not willing to agree to.</span></strong>
	</p>
	<p
		style="margin-top:0pt; margin-left:36pt; margin-bottom:0pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">By law,</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">we</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">must give</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">certain key information before a legally binding
			contract between</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">and</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">us</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">is made.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<strong><span style="font-family:'Times New Roman'; font-size:12pt; ">1</span></strong><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">Part one of the key
				information:</span></strong><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">&#xa0;</span></strong><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">‘Who we are’</span></strong>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">1.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">We</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">are</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">AirClass
			(Singapore) PTE. LTD.</span><strong><span
				style="font-family:'Times New Roman'; ">&#xa0;</span></strong><span
			style="font-family:'Times New Roman'">trading as</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass,</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">a company
			registered in Singapore under company number:</span><span
			style="font-family:'Times New Roman'; color:#6f777b; background-color:#ffffff">&#xa0;</span><span
			style="font-family:'Times New Roman'; color:#6f777b; background-color:#ffffff">202129373C</span><span
			style="font-family:'Times New Roman'">.</span>
	</p>
	<p
		style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">1.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">is only used
			as an online education and training platform.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<strong><span style="font-family:'Times New Roman'; font-size:12pt; ">2</span></strong><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">Part 2 of the key</span></strong><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">&#xa0;</span></strong><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">information:</span></strong><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">&#xa0;</span></strong><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">Your Statutory Rights</span></strong>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">2.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">You</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">do not have
			this right to cancel once a download has started provided</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">have been
			told this and have acknowledged this.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:54pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">2.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">Digital content must be as described, fit for purpose and of
			satisfactory quality.</span>
	</p>
	<p
		style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">2.3</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">If</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">your</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">digital
			content is faulty,</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you’re entitled to a repair or a replacement.</span>
	</p>
	<p
		style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">2.4</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">If the fault can’t be fixed, or if it hasn’t been fixed within a
			reasonable time and without significant inconvenience,</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">can get some,
			or all of</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">your</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">money
			back.</span>
	</p>
	<p
		style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">2.5</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">If</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">can show the
			fault has damaged</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">your</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">device
			and</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">we</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">haven’t used
			reasonable care and skill,</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">may be
			entitled to a repair or compensation.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<strong><span style="font-family:'Times New Roman'; font-size:12pt; ">3</span></strong><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">AirClass</span></strong><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">&#xa0;</span></strong><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">reminds you:</span></strong>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">3.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">You can browse the content of the website or APP or related link pages
			but cannot obtain</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">course
			services</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">without</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">account
			registration.</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">After</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">your</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">registration</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">of
			the</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">platform
			before this agreement takes effect, you can access and/or use the</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">platform
			website, client (including APP/APK/SDK/API methods), content distribution, information network
			dissemination, etc.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:54pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">3.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">Any access of the various forms (including the emergence of new
			service forms in future technological development) are</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">DEEMED</span><span
			style="font-family:'Times New Roman'; text-decoration:line-through">deemed</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">to be your
			consent to accept all the contents of this agreement, otherwise, please do not access or accept</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">platform
			services.</span>
	</p>
	<p
		style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">3.3</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">The details of this agreement will not be filed by</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">us. Please
			print out or save a copy of this contract for</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">your</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">records
			as</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">we</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">will not save
			a copy for</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you.</span>
	</p>
	<p
		style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">3.4</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">If</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">we</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">have to
			change any key information once a legally binding contract between</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">and</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">us</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">is
			made,</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">we</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">can only do
			this if</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">agree to
			it.</span>
	</p>
	<p
		style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">3.5</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">You must be a natural person with full civil capacity.</span>
	</p>
	<p
		style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">3.6</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">User registration refers to the process by which you log in to
			the</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">official
			website, fills in relevant information as required, and confirms that they agree to perform the
			"Agreement".</span>
	</p>
	<p
		style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">3.7</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">You shall be responsible for paying all taxable taxes due
			to</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">the transaction and obtaining of paid services, as well as all
			hardware, software, service and other expenses.</span>
	</p>
	<p
		style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">3.8</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">Any statements, notices, warnings, etc. made by</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">in various
			ways (including but not limited to web announcements, emails, SMS reminders, etc.) regarding the use of
			specific</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">network
			services are regarded as</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">part of this "Agreement".</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<strong><span style="font-family:'Times New Roman'; ">4</span></strong><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><strong><span
				style="font-family:'Times New Roman'; ">Confirmation and Acceptance of the Terms of the Registration
				Agreement</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">In</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">this agreement:</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">4.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">‘</span><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">we</span></strong><span
			style="font-family:'Times New Roman'; font-size:12pt">’, ‘</span><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">us</span></strong><span
			style="font-family:'Times New Roman'; font-size:12pt">’ or ‘</span><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">our</span></strong><span
			style="font-family:'Times New Roman'; font-size:12pt">’</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">means "AirClass (Singapore) PTE. LTD. "; and
			"AirClass", "this website"</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">4.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">‘</span><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">you</span></strong><span
			style="font-family:'Times New Roman'; font-size:12pt">’ or ‘</span><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">your</span></strong><span
			style="font-family:'Times New Roman'; font-size:12pt">’ means "User of</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">AirClass", the person buying online service
			from</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">us.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">4.3</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">AirClass</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">(agrees to provide related services based on the
			Internet and mobile networks (hereinafter referred to as "network services") in accordance with the
			provisions of this agreement and its operating rules published from time to time.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">4.4</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">This agreement is the</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">AirClass</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">user registration agreement ("Agreement"). In order
			to</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">receive the online education</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">services,</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you shall</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">carefully read and fully understand the terms of this
			"Agreement", including the exemption or limitation of</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">AirClass's</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">liability.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">4.5</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">Please read carefully and choose to accept or not to
			accept this "Agreement" (If you are the minors, you shall read with the legal guardian, and seek the consent
			and guidance of your parents or guardians before submitting personal information).</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">4.6</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">If you agree to accept all the terms of this
			"Agreement",</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you shall</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">complete all the registration procedures according to
			the prompts on the page, and click the "Request now!" button during the registration process, otherwise it
			will be deemed to not accept all the terms of this "Agreement" and terminate and withdraw from the
			application.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">4.7</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">After you successfully register our
			website,</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">AirClass</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">will give</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">a user account and corresponding password.</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">Your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">account and password shall be</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">carefully</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">kept by</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">yourself;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">shall be legally responsible for all activities and
			events conducted with</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">account. If</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">successfully registered</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">the account,</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">AirClass</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">will call each registered user</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">and</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">further introduce the company's related
			services.</span><a name="_01546d83-c451-4329-9ac4-64e39ce5a367"></a><a
			name="_6b45cc1e-3407-4e18-bd2e-20b71a1d3979"></a><a name="_7bb648ae-fd4c-4ccd-98ad-b473ea5c1f7c"></a><a
			name="_3187b50d-6418-4ddb-a5c1-f85f9118fe30"></a><a name="_fe739c50-9d39-47a3-b9a9-c578f9d7dd7a"></a><a
			name="_bc516f32-70f7-4095-8cd6-5b4704693a52"></a><a name="_Toc256000003"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<strong><span style="font-family:'Times New Roman'; ">5</span></strong><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><a
			name="_217e867b-aeeb-4aec-99d8-c3c39726767f"></a><strong><span
				style="font-family:'Times New Roman'; ">W</span></strong><strong><span
				style="font-size:10.5pt; ">e</span></strong><strong><span
				style="font-family:'Times New Roman'; ">&#xa0;</span></strong><strong><span
				style="font-family:'Times New Roman'; ">set out how a legally binding contract
				between</span></strong><strong><span
				style="font-family:'Times New Roman'; ">&#xa0;</span></strong><strong><span
				style="font-size:10.5pt; ">you</span></strong><strong><span
				style="font-family:'Times New Roman'; ">&#xa0;</span></strong><strong><span
				style="font-family:'Times New Roman'; ">and</span></strong><strong><span
				style="font-family:'Times New Roman'; ">&#xa0;</span></strong><strong><span
				style="font-size:10.5pt; ">us</span></strong><strong><span
				style="font-family:'Times New Roman'; ">&#xa0;</span></strong><strong><span
				style="font-family:'Times New Roman'; ">is made.</span></strong><a
			name="_ac3b9de9-1e2e-4a11-aec4-4d2a025fcea2"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">5.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">You</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">place an order on the site by [</span><a
			name="_cmntref1"><span style="font-family:'Times New Roman'; font-size:12pt">air-class.com</span></a><span
			style="font-family:'Times New Roman'; font-size:12pt">]. Please read and check</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">order carefully before submitting it.</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">You</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">will be able to correct any errors before
			submitting</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">order to</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">us.</span><a
			name="_f989596b-6e42-4e9c-9cfe-ef89c5c6b20e"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">5.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">Before</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">place</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">order,</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">must check that the hardware and software requirements
			of</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">computer or device mean that</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">can download the digital content. Please click on the
			‘key technical information’ button if</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">want to see the requirements.</span><a
			name="_1612973249-55567178"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">5.3</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">When</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">place</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">order at the end of the online purchase
			process,</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">we</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">will acknowledge it by email. This acknowledgement
			does not, however, mean that</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">order has been accepted by</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">us.</span><a name="_1582889131-44326825"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">5.4</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">We</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">may contact</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">to say that</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">we</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">do not accept</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">order. This is typically for the following
			reasons:</span><a name="_1582889131-430211425"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">5.4.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">the digital content is unavailable;</span><a
			name="_1582889131-453531325"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">5.4.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">we</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">cannot</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">authorise</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">payment;</span><a name="_1582889131-47389325"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">5.4.3</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">are not allowed to buy the digital content
			from</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">us;</span><a name="_1582889131-450761225"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">5.4.4</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">we</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">are not allowed to sell the digital content
			to</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you; or</span><a name="_1582889131-38660225"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">5.4.5</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">there has been a mistake on the pricing or description
			of the digital content.</span><a name="_1582889131-44591425"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">5.5</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">We</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">will only accept</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">order when</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">we</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">email</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">to confirm this (</span><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">Confirmation Email</span></strong><span
			style="font-family:'Times New Roman'; font-size:12pt">). At this point:</span><a
			name="_1582889131-476321125"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">5.5.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">a legally binding contract will be in place
			between</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">and</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">us; and</span><a name="_1582889131-47398425"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">5.5.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">the digital content will download
			automatically.</span><a name="_1582889131-47911225"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:114pt; margin-bottom:0pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">5.6</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">If</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">are under the age of 18</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">may not</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">buy any digital content from the site</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">unless</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">are supervised by your legal representative.</span><a
			name="_f1225865-e21d-4403-a59e-80af55bce383"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">5.7</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">When buying any online service on</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">our</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">site</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">also agree to be legally bound by:</span><a
			name="_6bc538d8-fc75-49b1-96ef-802cc212a230"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">5.7.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">our</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">website terms and</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">conditions</span><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">[</span></strong><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">and any documents referred to in
			them</span><strong><span style="font-family:'Times New Roman'; font-size:12pt; ">]</span></strong><span
			style="font-family:'Times New Roman'; font-size:12pt">;</span><a
			name="_a8ea1ffc-4ac8-4e22-9da6-7518d0edb8ee"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">5.7.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">agree to accept the company's further telephone
			services.</span><a name="_52de8084-9f38-4d08-9e81-79d95ccf8487"></a><a
			name="_cf270abe-4ee0-40f0-a940-e1016f966d3e"></a><a name="_7c947a75-0149-4570-93ab-7b082e88f4de"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">5.8</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">If</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">continue using</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">these</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">AirClass</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">network services, it is</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">deemed that</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you agree</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">the content of such statements, notices, and
			warnings.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">will publish
			an announcement on the website to notify</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">of the
			changes of the agreement</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">And</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">will</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">take</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">an</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">automatically</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">and</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">immediate</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">effect.</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">If</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">you
			do</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">not accept the modified terms, please stop using the network services
			provided by this website immediately,</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">otherwise</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">will be
			deemed to have accepted the modified agreement.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<strong><span style="font-family:'Times New Roman'; ">6</span></strong><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><strong><span
				style="font-family:'Times New Roman'; ">The Rights and Obligations of</span></strong><strong><span
				style="font-family:'Times New Roman'; ">&#xa0;</span></strong><strong><span
				style="font-family:'Times New Roman'; ">AirClass</span></strong>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">6.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">When</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">AirClass</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">supply the digital content:</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">6.1.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">will maintain
			a quality operation based on current technology, and use all reasonable efforts to ensure that it is free
			from defects, viruses and other malicious content.</span>
	</p>
	<p
		style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">6.1.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">we</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">do not
			promise that it is compatible with any</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">third party</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">software or
			equipment except where</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">we</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">have said
			that it is in the guide to its use or on</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">our</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">site;
			and</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">not responsible for the interrupted or suspended services caused by
			force majeure or other non-human factors.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">6.1.3</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">You</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">acknowledge
			that there may be minor errors or bugs in it.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">6.1.4</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">The digital content that</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">we</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">provide
			to</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">must be as
			described, fit for purpose and of satisfactory quality.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">6.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">shall</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">respondeffectively</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">to</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">the problems
			regarding</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">the transaction or registration-related</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">issues</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">you
			encountered</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">during the registration and use of the</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">online
			education platform;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">6.3</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">shall provide
			you with remote education services based on the principle of honesty and credibility, and shall not
			arbitrarily interrupt or stop the provision of such services.</span>
	</p>
	<p
		style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">6.4</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">has zero
			tolerance</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">for any</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">of</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">your</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">improper
			behavior on the</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">network
			education platform or any other situation.</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">or its
			authorized person</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">entitles</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">to</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">require
			you</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">to</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">
			reduce</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">the impact of your improper behavior, including but not limited to
			changing or deleting the content posted by you, and to suspend or terminate your right to use the network
			service</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">without</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">your</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">consent;</span>
	</p>
	<p
		style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">6.5</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">has the right
			to supervise and guide</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">your</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">online
			activities, and has the right to</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">terminate all</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">of
			your</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">services</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">
			if</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">engage in
			illegal online activities.</span>
	</p>
	<p
		style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">6.6</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">has the right
			to review and supervise the use of</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">network
			services by you,</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">including but not limited to reviewing the content stored by you
			in</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass.</span><a name="_Toc256000007"></a>
	</p>
	<p
		style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">6.7</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">has right to
			receive the</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">Payment</span><a
			name="_087f2a56-d624-4104-9396-9f725e15e6e4"></a><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">from you for
			the service supplied</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">to you:</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">6.7.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">We</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">accept the following credit cards and</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">online payment such as the Alipay or the payment of
			the</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">Wechat</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">We</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">do not accept cash or</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">cheques.</span><a
			name="_155bffb7-9b2d-42ca-ba30-bfff464a3018"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">6.7.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">We</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">will do all that</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">we</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">reasonably can to ensure that all of the
			information</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">give</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">us</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">when paying for the digital content is secure by using
			an encrypted secure payment mechanism. However, in the absence of negligence on</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">our</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">part, any failure by</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">us</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">to comply with this contract or</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">our</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">Privacy Policy</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">or breach by</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">us</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">of</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">our</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">duties under applicable laws,</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">we</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">will not be legally responsible to</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">for any loss that</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">may suffer if a</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">third party</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">gains</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">unauthorised</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">access to any information that</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">give</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">us.</span><a
			name="_91cdb4f6-fad1-422b-ad31-5bc2ed75b04e"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">6.7.3</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">Your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">credit card or</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">online payment</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">will only be charged once the</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">Confirmation Email</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">has been sent to</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you, at which point the download of the digital
			content starts automatically.</span><a name="_5a5e86a4-2831-46f4-9455-19dbc7f6282c"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">6.7.4</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">All payments by credit card or</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">online payments</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">need to be</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">authorised</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">by the relevant card issuer.</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">We</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">may also need to use extra security steps
			via</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">Verified code:</span><a
			name="_9ebd2859-680b-4e60-b7a1-2fb8ce7a532b"></a><a name="_b86491e1-9687-4405-be67-d334bf4dfda2"></a><a
			name="_e2c206d2-5e94-446f-a35c-a6f3c38ce9a5"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<a name="_1b6fcc59-6fbd-43da-9db0-9abe105b4d66"></a><a name="_179004c4-3339-4682-a3db-674982ecedad"></a><a
			name="_12032f91-796b-4d2b-8ec0-a2623d6eecc4"></a><a name="_7bbb4d32-a37f-42db-811e-c59c67778358"></a><a
			name="_3d783f9a-0c92-4d01-b345-9ca7ba102875"></a><a name="_Toc256000009"></a><span
			style="font-family:'Times New Roman'; font-size:12pt">6.8</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">Faulty</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">digital content</span><a
			name="_2e32de91-d379-4467-8abc-5c175ff3e929"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">6.8.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><a
			name="_287e90bd-f85f-4367-b8d7-3aa233c8bab8"></a><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><a
			name="_9f12bda9-2c3b-428a-bfde-e8194e992bf7"></a><span
			style="font-family:'Times New Roman'; font-size:12pt">If</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">digital content is faulty, please contact</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">us</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">using the contact details at the top of this
			page.</span><a name="_1fdf4a08-19eb-4ab7-be64-5bd182d77fa6"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">6.8.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">To avoid faults in the digital content,</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">must:</span><a
			name="_6e1919df-875b-4043-bd93-75b66b2800cb"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:Wingdings"></span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">install any fixes, updates new releases</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">and</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">new
			versions</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">as soon as reasonably possible after</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">we</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">tell</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">that they are
			available to be downloaded;</span><a name="_5ffc563f-9cbb-49b0-840e-0bb38cf5bc8d"></a><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">and</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:20pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-indent:-21pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:Wingdings"></span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">use it only on the recommended</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">third-party</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">software and
			equipment set out in the guide to its use or on</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">our</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">site.</span><a name="_4586fadb-fc13-43ac-9eb5-ccae9277f9ab"></a><a
			name="_57bf4eb4-ce38-47a8-9d38-6622a3bb5de5"></a>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<strong><span style="font-family:'Times New Roman'; ">7</span></strong><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><strong><span
				style="font-family:'Times New Roman'; ">The</span></strong><strong><span
				style="font-family:'Times New Roman'; ">&#xa0;</span></strong><strong><span
				style="font-family:'Times New Roman'; ">Rights and Obligations of User</span></strong>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">7.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">The law gives</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">certain legal rights (also known as ‘statutory
			rights’); and</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">7.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">Permission to use the digital content</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:18pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:Tahoma">&#xa0;</span><span style="font-family:Tahoma">&#xa0;</span><span
			style="font-family:'Times New Roman'">When</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">buy the
			digital content and it is downloaded,</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">will not own
			it.</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">Instead,</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">we</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">give</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">permission to
			use it for the purpose of</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">using and
			enjoying it according to this agreement.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:18pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">7.3</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">The digital content:</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">7.3.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">is personal to</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you.</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">You</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">can use it wherever</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">want in the world but only if</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">comply with local laws;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">7.3.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">is non-exclusive to</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you.</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">We</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">may supply the same or similar digital content to
			other users;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">7.3.3</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">may be used only on computers</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">or devices;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:108pt; margin-bottom:0pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">7.4</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">You</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">may not be:</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">7.4.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">copied by</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">except for a reasonable number of
			necessary</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">back-ups.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">7.4.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">changed by</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">which means, that</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">are not allowed to adapt, reverse-engineer or
			decompile it, or try to extract the source code from it, except where any of this is allowed by law;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">7.4.3</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">combined or merged with, or used in, any other
			computer program; or</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:99.2pt; margin-bottom:0pt; text-indent:-35.4pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">7.4.3.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">distributed or sold by</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">to any third party;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">7.4.4</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">contains information which is owned by</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">us</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">and/or third parties.</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">You</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">must not conceal, change or remove any markings which
			show who owns this information, such as copyright (©), registered trade mark (®) or unregistered trademark
			(™) markings.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">7.4.5</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">Except where</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">have permission to use the digital content under this
			clause,</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">will not obtain any rights of ownership or other
			rights (of whatever nature) in the digital content or in any copies of it.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">7.5</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">You</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">must comply
			with the following:</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">7.5.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">compiling</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">with all
			network protocols, regulations, procedures and practices</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">to</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">use</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">our</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">services;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">7.5.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">not using</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">the</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">online
			education platform to</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">for any</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">illegal</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">purpose
			or</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">activities;</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">7.5.3</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">not interfering</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">with
			the</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">use and</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">operation
			of</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">and</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">not
			infringing</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">the normal</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">rightsof</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">other
			users;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">7.5.4</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">not</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">allowing a
			third party</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">to access your account whatever with or</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">without</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">monetarilynor</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">for other
			purposes;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">7.5.5</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">be</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">tolerant</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">with
			the</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">technical</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">transferring</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">between</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">China</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">and</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">overseas,</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">and complying
			with</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">relevant laws and regulations</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">7.5.6</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">updating your registration information in time to ensure that your
			personal information is detailed and accurate when your personal registration information changes.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">7.5.7</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">providing accurate user name and password and contact information
			according to the registration prompts when registering;</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">All the
			information provided by you will be deemed to accurate and valid</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">ID.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">7.5.8</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">allowing the staff of the</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">to contact
			you for the purpose the use of their online education;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:22.5pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">7.6</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">Any breaches of</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">the</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">provisions</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">of Clause
			6,</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">has</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">its own
			judicial discretion</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">to immediately</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">close your
			account.</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">And,</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">You</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">shall
			be</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">liable</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">for</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">the
			consequence</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">of the</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">breachess</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">on</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">education
			platform.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:54pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">7.7</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">Equipping</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">yourself
			for</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">online education,</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">such as PC,
			modems or other necessary Internet devices;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">7.7.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">Bearing</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">the</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">costs for the
			use of this online education platform, such as the</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">Internet
			telephone fee, Internet information fee and education information fee</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">etc.
			Your</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">user-name and password</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">7.7.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">You shall be fully responsible for the security of your user-name
			(also known as account number) and password;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">7.7.3</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'">you shall notify us immediately, if you find any illegal use of your
			account,</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">will not
			release your liability for the use of accounts and passwords by a third party even incurred by hacking or
			your negligence.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:36pt; margin-bottom:0pt; text-indent:21pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<strong><span style="font-family:'Times New Roman'; ">8</span></strong><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><a
			name="_10e82c4e-53a3-4613-a3c4-b6d76004f086"></a><a name="_ced346bf-9c1c-465a-8b87-7026832647bd"></a><a
			name="_340f1983-5428-4b25-a40e-5e042a9ba962"></a><a name="_ccb63846-4c94-4f2f-a9b0-3d0d19f181c1"></a><a
			name="_0393d9d9-2319-4876-a820-1734ab5f095b"></a><a name="_c2d8dbf6-09d2-4266-a47e-aeaa1e6911a6"></a><a
			name="_4a557e3a-0d99-471b-891a-21ab7fa55244"></a><a name="_f6f97d58-04c4-4c4c-b526-56691fed11a6"></a><a
			name="_5b61a348-e779-4f86-b8fb-bf7ad3b8dff4"></a><a name="_ac376d3f-1d15-4bb5-9a6d-22e9bd88f44a"></a><a
			name="_469fd56d-b3ad-4047-8dd4-1ac64cb94446"></a><a name="_1ec32b0d-940d-467f-8a2e-81b1aef0e73c"></a><a
			name="_7f9333e6-17b2-4466-8415-792cc170bf32"></a><a name="_e9588e74-9dc0-48d9-9ba1-b5dea9614e6b"></a><a
			name="_17fdbac2-0aed-4e19-8886-e48403d817cc"></a><a name="_830524f4-9385-43ec-83c4-768f7eabbdca"></a><a
			name="_884718f9-d781-40d8-99a5-8a1ff6e4a589"></a><a name="_050fbd09-8e82-45ca-8f52-e9502270b6b9"></a><a
			name="_00a9c1dd-7109-4766-a930-ffe05f22a7b6"></a><a name="_Toc256000006"><strong><span
					style="font-family:'Times New Roman'; ">Download</span></strong></a><a
			name="_8c4fc406-e0b6-428a-bd38-822d50b3a1f1"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">8.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">Once</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">have placed</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">order and the</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">Confirmation Email</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">has been sent to</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you, the digital content will download
			automatically.</span><a name="_8ccac44e-3f0d-4919-8a40-47aa216441b4"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">8.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">We</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">may deliver</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">digital content in instalments.</span><a
			name="_02db3a43-fab6-40c8-99f5-54605b840411"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">8.3</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">If something happens which is outside of</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">our</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">control and affects</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">ability to download the digital content,</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">we</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">will let</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">know when</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">can expect to be able to download the digital
			content.</span><a name="_765bc153-bf52-4cef-89d1-26298fbac3c3"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">8.4</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">If</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">computer or device blocks the automatic download of
			the digital content or the automatic download does not start,</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">may still have the right to cancel the contract. If
			this happens, please contact</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">us</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">using the contact details at the</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">end</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">of this</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">agreement.</span><a name="_1582891063-42793125"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<strong><span style="font-family:'Times New Roman'; ">9</span></strong><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><a
			name="_f5ca0fc2-55ab-43ca-a63d-96c17dcf9302"></a><a name="_Toc256000011"><strong><span
					style="font-family:'Times New Roman'; ">Limitation on our liability</span></strong></a><a
			name="_58febe85-b527-4522-8099-3573c2339390"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">9.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">Except for any legal responsibility that</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">we</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">cannot exclude in law (such as for death or personal
			injury) or arising under applicable laws relating to the protection of</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">personal information,</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">we</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">are not legally responsible for any:</span><a
			name="_76321a1f-68b1-427a-9d90-96e3bcb27e21"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">9.1.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">losses that were not foreseeable to</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">and</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">us</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">when this</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">agreement</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">was formed;</span><a
			name="_32541001-d49f-40f2-a243-913ae09426db"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">9.1.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">losses that were not caused by any breach
			on</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">our</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">party;</span><a name="_1613496475-66854125"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">9.1.3</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">business losses; or</span><a
			name="_eec9a248-9840-447b-a406-723230e0a482"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:70.9pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">9.1.4</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">losses to non-consumers.</span><a
			name="_1c1036de-ed35-407c-93e3-a3ad70e93070"></a>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<strong><span style="font-family:'Times New Roman'; ">10</span></strong><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><a name="_Toc256000002"><strong><span
					style="font-family:'Times New Roman'; ">Your privacy and personal information</span></strong></a><a
			name="_1518623016-402301527"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">10.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">Our</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><strong><span
				style="font-family:'Times New Roman'; font-size:12pt; ">Privacy Policy</span></strong><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">is available at </span><a name="_cmntref2"><span
				style="font-family:'Times New Roman'; font-size:12pt">[air-class.com]</span></a><span style="font-family:'Times New Roman'; font-size:12pt">.</span><a
			name="_1518626009-47106527"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">10.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">Your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">privacy and personal information are important
			to</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">us. Any personal information that</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">provide to</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">us</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">will be dealt with in line with</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">our</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">Privacy Policy,</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">10.3</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">We might contact you with the</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">information</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">we</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">collect from</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you, if</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">we</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">have a query or</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">concern</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">about the use of</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">your</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">account.</span><a name="_1518626008-39725427"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<strong><span style="font-family:'Times New Roman'; ">11</span></strong><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><a name="_Toc256000012"><strong><span
					style="font-family:'Times New Roman'; ">Third party rights</span></strong></a><a
			name="_409e7914-daa5-4e8a-9886-bf2eaedfa87f"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:36pt; margin-bottom:0pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">No one other than a party to this contract has any
			right to enforce any term of this contract.</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<strong><span style="font-family:'Times New Roman'; ">12</span></strong><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><a name="_Toc256000013"><strong><span
					style="font-family:'Times New Roman'; ">Disputes</span></strong></a><a
			name="_62ea0121-7d55-4c7d-b754-53d31eafaf51"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">12.1</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">We</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">will</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">try to resolve any disputes with</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">quickly and efficiently. If</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">are unhappy with the digital content</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">purchased,</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">our</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">service to</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">or any other matter, please contact</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">us</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">as soon as possible using the contact details set out
			at the top of this page.</span><a name="_e83d84fb-def1-4ea9-bca5-6e51799ff2ba"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">12.2</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><a name="_1617096359-40449625"></a><span
			style="font-family:'Times New Roman'; font-size:12pt">If a dispute cannot be resolved in accordance
			with</span><span style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">our</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">Complaint Handling Policy</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">or</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">are unhappy with the outcome,</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">may want to use alternative dispute resolution
			(</span><strong><span style="font-family:'Times New Roman'; font-size:12pt; ">ADR</span></strong><span
			style="font-family:'Times New Roman'; font-size:12pt">).</span><a
			name="_9f4a86dc-2c74-4507-8dfa-df12cd7e1a25"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">12.3</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><a
			name="_57100ea7-c4a7-4979-a1ab-0bf6c38645ac"></a><span
			style="font-family:'Times New Roman'; font-size:12pt">If</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">do not wish to use</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">ADR</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">or are unhappy with the outcome of ADR,</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">you</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt">can still bring court proceedings.</span><a
			name="_1613496889-53256825"></a>
	</p>
	<p
		style="margin-top:0pt; margin-left:49.6pt; margin-bottom:0pt; text-indent:-28.35pt; text-align:left; line-height:13.8pt; widows:2; orphans:2">
		<span style="font-family:'Times New Roman'; font-size:12pt">12.4</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><a name="_1629821316-491662136"></a><span
			style="font-family:'Times New Roman'; font-size:12pt">Any disputes will be referred to and finally resolved
			by arbitration administered by the Singapore International Arbitration Centre (“SIAC”) in accordance with
			the Arbitration Rules of the Singapore International Arbitration Centre (“SIAC Rules”) for the time being in
			force. The seat of the arbitration shall be Singapore. </span><a
			name="_f6cca254-e538-475b-a71d-15fa52f3ec14"></a>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<strong><span style="font-family:'Times New Roman'; ">13</span></strong><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><strong><span
				style="font-family:'Times New Roman'; ">Legal Jurisdiction</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">The laws of Singapore and SIAC apply to conclusion, execution,
			interpretation and dispute resolution of this agreement, although if</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">are resident
			elsewhere</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">will retain
			the benefit of any mandatory protections given to</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">by the laws
			of that country.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<strong><span style="font-family:'Times New Roman'; ">14</span></strong><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><strong><span
				style="font-family:'Times New Roman'; ">Intellectual Property</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">AirClass</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">owns
			all</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">thel</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">intellectual
			property rights</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">of the</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">contents
			of</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass's</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">supplied on
			the</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">platform.</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">Without</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">our</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">permission,</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">no one
			entitles to</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">copy, disseminate</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">or
			infringe</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">any of</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">AirClass's</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">intellectual
			property rights.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<strong><span style="font-family:'Times New Roman'; ">15</span></strong><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><strong><span
				style="font-family:'Times New Roman'; ">Copyright Notice</span></strong>
	</p>
	<p
		style="margin-top:0pt; margin-right:9.75pt; margin-bottom:0pt; text-align:left; line-height:14.65pt; widows:2; orphans:2; background-color:#ffffff">
		<span style="font-family:'Times New Roman'; font-size:12pt">AirClass</span><span
			style="font-family:'Times New Roman'; font-size:12pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt;>is the proprietor or licensee
			(‘rightsholder’) of all intellectual property rights in relation to this online platform and its contents,
			including but not limited to copyright, trade and brand names,</span><a name="ORIGHIT_10"></a><a
			name="HIT_10"></a><span
			style="font-family:'Times New Roman'; font-size:12pt;>&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt;>trade-marks, products and get-up. If no
			permission is given by</span><span
			style="font-family:'Times New Roman'; font-size:12pt;>&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt;>AirClass</span><span
			style="font-family:'Times New Roman'; font-size:12pt;>&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:12pt;>to the use of any of them, such use may
			constitute an infringement of the rightsholder’s rights.</span>
	</p>
	<p
		style="margin-top:0pt; margin-right:9.75pt; margin-bottom:0pt; text-align:left; line-height:14.65pt; widows:2; orphans:2; background-color:#ffffff">
		<a name="ORIGHIT_11"></a><a name="HIT_11"></a><a name="ORIGHIT_12"></a><a name="HIT_12"></a><span
			style="font-family:'Times New Roman'; font-size:12pt;>Permission to reproduce such material
			must be obtained from the relevant rights holders concerned.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p
		style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<strong><span style="font-family:'Times New Roman'; ">16</span></strong><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><span
			style="font-family:'Times New Roman'; font-size:7pt">&#xa0;</span><strong><span
				style="font-family:'Times New Roman'; ">Termination of the Agreement</span></strong>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">You have the right to terminate this Agreement</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">at any time
			by giving us one-month notice in writing</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">saying</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">that</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">you</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">do not want
			to continue to use the relevant platform services.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">Our contact</span><span
			style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">email account
			is</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
			style="font-family:'Times New Roman'">‘contact@air-class.com’</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:12pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:14pt">
		<span style="font-family:'Times New Roman'">&#xa0;</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:right; widows:2; orphans:2; font-size:14pt">
		<span style="font-family:'Baskerville Old Face'">AirClass (Singapore) PTE. LTD.</span>
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:9pt">
		&#xa0;
	</p>
	<p style="margin-top:0pt; margin-bottom:0pt; text-align:left; widows:2; orphans:2; font-size:9pt">
		<span style="font-family:Tahoma">&#xa0;</span>
	</p>`
}
